'use strict';

exports.__esModule = true;
exports.default = {
  el: {
    colorpicker: {
      confirm: 'Sahkan',
      clear: 'Buang'
    },
    datepicker: {
      now: 'Sekarang',
      today: 'Hari Ini',
      cancel: 'Batal',
      clear: 'Buang',
      confirm: 'Sahkan',
      selectDate: 'Pilih Tarikh',
      selectTime: 'Pilih Masa',
      startDate: 'Tarikh Mula',
      startTime: 'Masa Mula',
      endDate: 'Tarikh Tamat',
      endTime: 'Masa Tamat',
      prevYear: 'Tahun Sebelumnya',
      nextYear: 'Tahun Selepasnya',
      prevMonth: 'Bulan Sebelumnya',
      nextMonth: 'Nulan Selepasnya',
      year: 'Tahun',
      month1: 'Januari',
      month2: 'Februari',
      month3: 'Mac',
      month4: 'April',
      month5: 'Mei',
      month6: 'Jun',
      month7: 'Julai',
      month8: 'Ogos',
      month9: 'September',
      month10: 'Oktober',
      month11: 'November',
      month12: 'Disember',
      // week: 'Week',
      weeks: {
        sun: 'Ahad',
        mon: 'Isnin',
        tue: 'Selasa',
        wed: 'Rabu',
        thu: 'Khamis',
        fri: 'Jumaat',
        sat: 'Sabtu'
      },
      months: {
        jan: 'Januari',
        feb: 'Februari',
        mar: 'Mac',
        apr: 'April',
        may: 'Mei',
        jun: 'Jun',
        jul: 'Julai',
        aug: 'Ogos',
        sep: 'September',
        oct: 'Oktober',
        nov: 'November',
        dec: 'Disember'
      }
    },
    select: {
      loading: 'Sedang dimuatkan',
      noMatch: 'Tiada Data yang Sepadan',
      noData: 'Tiada Data',
      placeholder: 'Sila Pilih'
    },
    cascader: {
      noMatch: 'Tiada Data yang Sepadan',
      loading: 'Sedang dimuatkan',
      placeholder: 'Sila Pilih',
      noData: 'Tiada Data'
    },
    pagination: {
      goto: 'Beralih ke',
      pagesize: 'Artikel/Halaman',
      total: 'Jumlah {total} Artikel',
      pageClassifier: 'Halaman'
    },
    messagebox: {
      title: 'Tip',
      confirm: 'Sahkan',
      cancel: 'Batal',
      error: 'Date yang dimasukkan tidak sah!'
    },
    upload: {
      deleteTip: "Klik 'Padam' untuk padamkan",
      delete: 'Padam',
      preview: 'Pratonton Imej',
      continue: 'Terus muat naik'
    },
    table: {
      emptyText: 'Tiada Data',
      confirmFilter: 'Sahkan Penapis',
      resetFilter: 'Set semula Penapis',
      clearFilter: 'Buangkan Penapis',
      sumText: 'Jumlah'
    },
    tree: {
      emptyText: 'Tiada Data'
    },
    transfer: {
      noMatch: 'Tiada Data yang Sepadan',
      noData: 'Tiada Data',
      titles: ['Jadual 1', 'Jadual 2'],
      filterPlaceholder: 'Sila masukkan kandungan carian',
      noCheckedFormat: 'Jumlah {total} Item',
      hasCheckedFormat: 'Item yang disemak {checked}/{total} Jumlah Item'
    },
    image: {
      error: 'Gagal dimuatkan'
    },
    pageHeader: {
      title: 'Kembali'
    },
    popconfirm: {
      confirmButtonText: 'Sahkan',
      cancelButtonText: 'Batal'
    },
    empty: {
      description: 'Tiada Data'
    }
  }
};